import { Button, CartAddIcon, constants, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';

export interface AddToCartButtonProps {
  loading?: boolean;
  formId?: string;
  size?: 'medium' | 'large' | 'xlarge';
  hideIcon?: boolean;
  fontSize?: string;
  presale?: boolean;
  outOfStock?: boolean;
}

export const messages = defineMessages({
  addToCart: {
    defaultMessage: 'Add to cart',
  },
  presale: {
    defaultMessage: 'Pre-order',
  },
  outOfStock: {
    defaultMessage: 'Out of stock',
  },
});

export const AddToCartButton = ({
  loading,
  formId,
  size = 'large',
  hideIcon,
  fontSize,
  presale,
  outOfStock,
}: AddToCartButtonProps) => {
  const intl = useIntl();

  return (
    <Button
      loading={loading}
      intent={constants.PRIMARY}
      strong
      fluid
      size={constants[size.toUpperCase()]}
      data-testid="add-to-cart-button"
      type="submit"
      form={formId}
      disabled={outOfStock}
    >
      {!outOfStock && !hideIcon && <CartAddIcon size="medium" />}
      <Text marginLeft={hideIcon ? '' : 's'} type={fontSize}>
        {outOfStock
          ? intl.formatMessage(messages.outOfStock)
          : presale
            ? intl.formatMessage(messages.presale)
            : intl.formatMessage(messages.addToCart)}
      </Text>
    </Button>
  );
};
